import React, { memo } from "react";

import SkeletonPlaceholder from "@/components/molecules/SkeletonPlaceholder";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props for SkeletonActivityFeedItemView component
 */
interface Props {
  isSmallScreen: boolean;
  isDark: boolean;
}

/**
 * Pure view component for activity feed item skeleton
 * @param root0 - Component props
 * @param root0.isSmallScreen - Whether to render small screen layout
 * @param root0.isDark - Whether dark theme is active
 */
const SkeletonActivityFeedItemView = ({ isSmallScreen, isDark }: Props) => (
  <SkeletonPlaceholder>
    <Stack
      direction="horizontal"
      className={`items-center gap-3 ${isSmallScreen ? "py-3" : "rounded-lg p-2"}`}
    >
      <Box
        className={`${isSmallScreen ? "size-10" : "size-12"} animate-pulse rounded-full opacity-70 ${
          isDark ? "bg-surface-strong" : "bg-surface-muted"
        }`}
      />
      <Stack className="flex-1 gap-2">
        <Box
          className={`h-5 w-3/4 animate-pulse rounded-none opacity-70 ${
            isDark ? "bg-surface-strong" : "bg-surface-muted"
          }`}
        />
        <Box
          className={`h-4 w-1/2 animate-pulse rounded-none opacity-70 ${
            isDark ? "bg-surface-strong" : "bg-surface-muted"
          }`}
        />
      </Stack>
      {!isSmallScreen && (
        <Box
          className={`h-3 w-16 animate-pulse rounded-none opacity-70 ${
            isDark ? "bg-surface-strong" : "bg-surface-muted"
          }`}
        />
      )}
    </Stack>
  </SkeletonPlaceholder>
);

SkeletonActivityFeedItemView.displayName = "SkeletonActivityFeedItemView";

export default memo(SkeletonActivityFeedItemView);
